<div class="step-wrapper">
  
  <div class="progress-line-bg"></div>
  <div class="progress-line-fill" [style.width]="(ind * 33.33) + '%'"></div>

  <div class="steps-container">
    
    <div class="step-item" [class.completed]="ind > 0" [class.current]="ind === 0">
      <div class="circle">
        <i class="fa-solid fa-basket-shopping" *ngIf="ind <= 0"></i>
        <i class="fa-solid fa-check" *ngIf="ind > 0"></i>
      </div>
      <span class="label">Panier</span>
    </div>

    <div class="step-item" [class.completed]="ind > 1" [class.current]="ind === 1" [class.future]="ind < 1">
      <div class="circle">
        <i class="fa-solid fa-map-location-dot" *ngIf="ind <= 1"></i>
        <i class="fa-solid fa-check" *ngIf="ind > 1"></i>
      </div>
      <span class="label">Adresse</span>
    </div>

    <div class="step-item" [class.completed]="ind > 2" [class.current]="ind === 2" [class.future]="ind < 2">
      <div class="circle">
        <i class="fa-regular fa-credit-card" *ngIf="ind <= 2"></i>
        <i class="fa-solid fa-check" *ngIf="ind > 2"></i>
      </div>
      <span class="label">Paiement</span>
    </div>

    <div class="step-item" [class.completed]="ind > 3" [class.current]="ind === 3" [class.future]="ind < 3">
      <div class="circle">
        <i class="fa-solid fa-thumbs-up"></i>
      </div>
      <span class="label">Terminé</span>
    </div>

  </div>
</div>